import {Brick, registerBrick} from 'olympe';

/**
 * Parse the response received from the authorization API, return array of authorized object
 */
export default class ParseAuthorizations extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} authorizations
     * @param {function()} forwardEvent
     * @param {function(string)} setCompanyCode
     * @param {function(string)} setPurchaseOrganization
     * @param {function(string)} setPurchasingGroup
     * @param {function(string)} setPlant
     */
    update($, [authorizations], [forwardEvent, setCompanyCode, setPurchaseOrganization, setPurchasingGroup, setPlant]) {
        const auth = JSON.parse(authorizations);
        // // For each type of permissions, keep only the concerned property, and remove the empty string
        const companyCodes = auth.d.results
            .filter((metadata) => metadata.CompCode)
            .map((metadata) => ({
                company_code: metadata.CompCode.toString(),
                activity: metadata.Activity.toString(),
            }));
        const purchaseOrgs = auth.d.results
            .filter((metadata) => metadata.PurchOrg)
            .map((metadata) => ({
                purchase_organization: metadata.PurchOrg.toString(),
                activity: metadata.Activity.toString(),
            }));
        const purchasingGrps = auth.d.results
            .filter((metadata) => metadata.PurchGrp)
            .map((metadata) => ({
                purchasing_group: metadata.PurchGrp.toString(),
                activity: metadata.Activity.toString(),
            }));
        const plants = auth.d.results
            .filter((metadata) => metadata.Plant)
            .map((metadata) => ({
                plant: metadata.Plant.toString(),
                activity: metadata.Activity.toString(),
            }));

        setCompanyCode(JSON.stringify(companyCodes));
        setPurchaseOrganization(JSON.stringify(purchaseOrgs));
        setPurchasingGroup(JSON.stringify(purchasingGrps));
        setPlant(JSON.stringify(plants));
        forwardEvent();
    }
}

registerBrick('017fb102cdf1f70ea017', ParseAuthorizations);
